import React, { Component } from 'react'
import { post } from '../../../utils/networking'
import ForgotPasswordForm from '../../forgotPassword'
import { Route, NavLink, HashRouter } from "react-router-dom";
import $ from 'jquery'
import { jsonFromUrlParam } from '../../../utils'
import * as Notification from '../../../notification'
import ReCAPTCHA from 'react-google-recaptcha'
import './style.css'

export class LoginForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isVerify: false
        }
    }

    submitHandle() {
        var { email_value, pass_value } = this.refs;
        email_value.value = email_value.value.replace(/\s/g, "")
        Notification.hide();
        if (email_value.value.length > 0 && pass_value.value.length > 0 && this.state.isVerify === true) {
            if (document.getElementById("input_mail").validity.patternMismatch) {
                Notification.show($("#email_box"), "Please match the requested email format.", "fail", "1");
            }
            else {
                document.getElementById("partner_load_panner").classList.add("show_panner");

                const param = {
                    email: email_value.value.toLowerCase(),
                    password: pass_value.value
                }

                post('auth/token', param, "partner", result => {
                    window.localStorage.setItem("partner_access_token", result.access_token)
                    var redirect = jsonFromUrlParam(this.props.location.search).redirect
                    if (redirect)
                        window.location.href = redirect.replace("%2F", "/")
                    else
                        window.location.href = "/partner"

                    if (document.getElementById("partner_load_panner"))
                        document.getElementById("partner_load_panner").classList.remove("show_panner");
                }, errors => {
                    Notification.show($("#submit_button"), errors.errors[0], "fail", "0");
                    if (document.getElementById("partner_load_panner"))
                        document.getElementById("partner_load_panner").classList.remove("show_panner");
                })

            }
        }
        else {
            if (email_value.value.length <= 0)
                Notification.show($("#email_box"), "Email is empty.", "fail", "1");
            if (pass_value.value.length <= 0)
                Notification.show($("#pass_box"), "Password is empty.", "fail", "1");
            if (this.state.isVerify === false)
                Notification.show($("#submit_button"), "Please prove you are not a robot.", "fail", "0");
        }
    }

    handleLoginFacebook(response) {
        const param = {
            token: response.tokenDetail.accessToken,
            type: "Facebook"
        }

    }

    verifyCallback() {
        this.setState({ isVerify: true });
    }

    render() {
        $("html, body").animate({ scrollTop: 0 }, 400);
        return (
            <div id="login_page" className="user_page partner_page">
                <div id="login_title">

                </div>
                <div id="login_form">
                    <p className="title">For Business Partners Only</p>
                    <div id="login_detail">
                        <div id="column_left" className="column">
                            <p>Questions</p>
                            <NavLink to="/faqs">Partner FAQ</NavLink>
                            <NavLink to="#">Nail spa of america Gift Card Redemption Instructions</NavLink>
                            <NavLink to="#">Spawish Gift Card Redemption Instructions</NavLink>
                            <p>Not a Business Partner?</p>
                            <span>Get your business listed on the largest wellness network in the world and starting accepts the best wellness gift card in the industry. </span>
                            <NavLink to="#">Learn more about signing up</NavLink>
                        </div>
                        <div id="column_space" className="column">
                            <fieldset>
                            </fieldset>
                        </div>
                        <div id="column_right" className="column">
                            <span className="title"> Login</span>
                            <span className="space">or</span>
                            <span id="create_account_link">
                                <NavLink to="/register-partner">Join the Network</NavLink>
                            </span>
                            <div id="email_box" className="login_value">
                                <span>E-Mail:</span>
                                <input type="text" id="input_mail" ref="email_value" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$" placeholder="yourmail@example.com" />
                            </div>
                            <div id="pass_box" className="login_value">
                                <span>Password:</span>
                                <input type="password" id="input_pass" ref="pass_value" />
                            </div>
                            <span id="forgot_pass_link">
                                <span onClick={() => { this.forgotPasswordForm.showForm(); }}>Forgot password?</span>
                            </span>
                            <div id="login_captcha">
                                <ReCAPTCHA
                                    ref="recaptcha"
                                    sitekey="6Lc0MUUUAAAAACvMe9KDmSoxrpwYcDXHXeqsONW2"
                                    onChange={this.verifyCallback.bind(this)}
                                    className="captcha"
                                />
                            </div>
                            <div id="submit_button">
                                <button onClick={this.submitHandle.bind(this)}>Login</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="partner_load_panner">
                    <div className="animationload">
                        <div className="osahanloading"></div>
                    </div>
                </div>
                <ForgotPasswordForm isPartner={true} ref={instance => { this.forgotPasswordForm = instance; }} />
            </div>
        )
    }
}

export default LoginForm


// WEBPACK FOOTER //
// ./src/components/partner/login/index.js